// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3-nPk","calendarButtons":"ClockData_calendarButtons__3gboG"};